/** Vite `public/i/markers/{id}.png` → `${BASE_URL}i/markers/{id}.png`. */
const base = import.meta.env.BASE_URL;

/** 1-based problem id → marker image URL */
export const MARKER_ICON_BY_ID = {
  1: `${base}i/markers/1.png`,
  2: `${base}i/markers/2.png`,
  3: `${base}i/markers/3.png`,
  4: `${base}i/markers/4.png`,
  5: `${base}i/markers/5.png`,
  6: `${base}i/markers/6.png`,
  7: `${base}i/markers/7.png`,
  8: `${base}i/markers/8.png`,
};
